export const passwordPattern = `(?=.*?[A-Z])(?=.*?[#?!@$.%^&*-]).{10,}`;
export const passwordRegExp = new RegExp(passwordPattern);

export default { passwordPattern, passwordRegExp };
